import { Link } from "react-router-dom";
import { useSeo } from "../lib/seo";
import { FAQS } from "../data/content";
import { PageIntro } from "../components/site/Sections";
import { FaqList } from "../components/site/FaqList";

export default function Faq() {
  useSeo("FAQ", "Answers to common questions about Deaf Education Consulting LLC: in-person and virtual services, IEP support, Visual Phonics training, booking and quotes.");
  return (
    <>
      <PageIntro eyebrow="FAQ" title="Questions, answered" testid="faq-intro" />
      <section className="bg-cream text-ink pb-24 md:pb-32">
        <div className="max-w-6xl mx-auto px-6 grid md:grid-cols-[1fr_2fr] gap-12">
          <div className="bg-sky rounded-2xl p-6 self-start">
            <p className="font-display text-2xl">Still have a question?</p>
            <p className="mt-2 text-slate">Send a consultation request and Michelle will reply by email.</p>
            <Link to="/contact#consultation" className="mt-5 inline-flex font-sans bg-teal text-paper rounded-full px-6 py-3 hover:bg-teal-deep transition-colors" data-testid="faq-consultation-cta">Request a consultation</Link>
          </div>
          <FaqList items={FAQS} prefix="faq" />
        </div>
      </section>
    </>
  );
}
